export default function GlobalSection() {
  return (
    <section className="py-20 bg-gradient-to-br from-[#4a5f8f] via-[#5a6fa0] to-[#6a7fb0]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 animate-fade-in">
          <h2 className="text-4xl font-bold text-white mb-4">왜 레알타드를 선택해야 할까요?</h2>
          <p className="text-xl text-white/90">레알타드의 토토 솔루션은 이미 많은 국가에서 사용되어 검증되었습니다.</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 text-center animate-fade-in-up">
            <h3 className="text-5xl font-bold text-white mb-3">3,700,000+</h3>
            <p className="text-xl text-white/90">플레이어</p>
            <p className="text-white/80 mt-2">일 평균 활성 플레이어</p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 text-center animate-fade-in-up" style={{ animationDelay: '100ms' }}>
            <h3 className="text-5xl font-bold text-white mb-3">13+</h3>
            <p className="text-xl text-white/90">개국 글로벌 파트너</p>
            <p className="text-white/80 mt-2">전 세계 13+ 개국에서 검증된 솔루션</p>
          </div>
        </div>

        <div className="text-center mb-12 animate-fade-in">
          <h3 className="text-3xl font-bold text-white mb-4">글로벌 지원</h3>
          <p className="text-xl text-white/90">"우리는 언어와 시장에 관계없이 전 세계에 해외 배팅 솔루션을 제공합니다."</p>
        </div>

        <div className="relative mb-12 animate-fade-in">
          <img 
            src="https://winka.io/wp-content/uploads/2024/02/graphic-101.webp" 
            alt="Global Map"
            className="w-full h-auto rounded-2xl"
          />
        </div>

        <div className="flex flex-wrap justify-center gap-4 animate-fade-in">
          {[
            'https://winka.io/wp-content/uploads/2024/02/country-flag-brazil.webp',
            'https://winka.io/wp-content/uploads/2024/02/country-flag-canada-1.webp',
            'https://winka.io/wp-content/uploads/2024/02/country-flag-costa-rica-1.webp',
            'https://winka.io/wp-content/uploads/2024/02/country-flag-cyprus-1.webp',
            'https://winka.io/wp-content/uploads/2024/02/country-flag-greece-1.webp',
            'https://winka.io/wp-content/uploads/2024/02/country-flag-india-1.webp',
            'https://winka.io/wp-content/uploads/2024/02/country-flag-indonesia-1.webp',
            'https://winka.io/wp-content/uploads/2024/02/country-flag-japan-1.webp',
            'https://winka.io/wp-content/uploads/2024/02/country-flag-latvia-1.webp',
            'https://winka.io/wp-content/uploads/2024/02/country-flag-malaysia-1.webp',
            'https://winka.io/wp-content/uploads/2024/02/country-flag-malta-1.webp',
            'https://winka.io/wp-content/uploads/2024/02/country-flag-philippines-1.webp',
            'https://winka.io/wp-content/uploads/2024/02/country-flag-russia-1.webp',
            'https://winka.io/wp-content/uploads/2024/02/country-flag-south-korea-1.webp',
            'https://winka.io/wp-content/uploads/2024/02/country-flag-sweden-1.webp',
            'https://winka.io/wp-content/uploads/2024/02/country-flag-thailand-1.webp',
            'https://winka.io/wp-content/uploads/2024/02/country-flag-united-kingdom-1.webp',
            'https://winka.io/wp-content/uploads/2024/02/country-flag-vietnam-1.webp'
          ].map((flag, index) => (
            <div key={index} className="w-16 h-16 rounded-full overflow-hidden shadow-lg hover:scale-110 transition-transform duration-300">
              <img src={flag} alt={`Country ${index + 1}`} className="w-full h-full object-cover" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
